import { BrowserCacheLocation } from '@azure/msal-browser';
import { environment as mainEnvironment } from '../environment';
import { Module } from '@shared/enums/Module';

export const environment = {
    ...mainEnvironment,
    production: true,
    projectName: 'trs',
    projectTitle: 'TR&S Reporting Tool',
    apiUrl: 'https://api.int.trs-reporting.siemens.cloud/v1',
    projectConfiguration: {
        availableLanguages: ['en'],
        modules: [
            Module.Hyperlinks,
            Module.Reports,
            Module.ReportTemplates,
            Module.SummaryReports,
            Module.Organisation,
            Module.CascadedReporting,
            Module.Mailing,
            Module.Faq
        ]
    },
    msalConfig: {
        auth: {
            clientId: 'b401b1ed-5b78-4980-b8ed-d2ecc43337c2', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.int.trs-reporting.siemens.cloud/App.Access'],
            uri: 'https://api.int.trs-reporting.siemens.cloud/v1'
        },
        {
            scopes: ['https://api.scd.suites.siemens.cloud/SCD.Read'],
            uri: 'https://api.scd.suites.siemens.cloud/v2/persons'
        }
    ]
};
